module.exports = __webpack_public_path__ + "img/play.f27e5a8f.svg";